angular.module("vgresiduos").filter("localeOrderBy", function () {
	"use strict";
	return Vgr.filters.localeOrderBy;
});
